import { Component, OnInit, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef, OnDestroy, ElementRef } from "@angular/core";
import { MenuService } from "./menu.service";
import { Location } from "@angular/common";
import { MatInput, MatTabChangeEvent } from "@angular/material";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { CoreLogService } from "../../services/log.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { SnackBarMessageType, SortDirection, ContentType, ItemTagStatusType, ItemTagType } from "../../shared/contentTypes";
import { Paging } from "../../shared/paging";
import { PagingHelper } from "../../shared/pagingHelper";
import { SortOption } from "../../shared/models/sort.model";
import { Subscription } from "rxjs";
import { ItemGroupMenuViewModel, MenuSettings_SortType, UsingType, ItemTagViewModel, WebshopSettingsDataModel2 } from "../../shared/models";
import { ScrollHelper } from "../../shared/scrollHelper";
import Utils from "../../shared/utils";
import { plopInOut } from "../../shared/animation/component.animation";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { NavigationService } from "../../services/navigation.service";
import { EMenuService } from "../../services/emenu.service";
import { SwiperConfigInterface } from "ngx-swiper-wrapper";
import { WebShopService } from "../../services/webShop.service";
import { WebShopMode } from "../../services/IWebShopService";
import { ArticleCardOptions } from "../../directives/articleCard/articleCard.component";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { MaterialTabHelperService } from "../../services/materialTabHelper.service";
import { RouterHelperService } from "../../services/routerHelper.service";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { FilterTagDialogComponent } from "../../modalDialogs";
import * as _ from "lodash";
import { ItemTagHelperService } from "../../services/itemTagHelper.service";
import { IProductViewModel } from "../../shared/models/product.facade";
import { CoreLanguageService } from "../../services/language.service";
import { MenuNavDialogComponent } from "../../modalDialogs";
import { CalendarComponent } from "../../directives/calendar/calendar.component";
import { WebVoucherService } from "../../services/web_voucher.service";

@Component({
  selector: "ya-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
  providers: [OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [plopInOut]
})
export class MenuComponent implements OnInit, OnDestroy {

  public emptybasket: boolean = true;
  public itemsInBasket: number = 0;
  public WebShopMode = WebShopMode;
  private webshopSettings: WebshopSettingsDataModel2;

  public activeItemGroupId: number;
  private locationFilterId: number = 0;
  private pagingHelper: PagingHelper;
  private pageSize: number = 4;
  private sortOption: SortOption[];
  private menuSettingSortType: number;

  public productViewmodels: IProductViewModel[] = [];
  public itemGroups: ItemGroupMenuViewModel[] = [];
  public hasData: boolean = true; // check if there is data for this page;
  public pageTitle = ""; // Used as a title at the header of the page
  public paging: Paging<IProductViewModel>[] = [];
  public currentItemGroupIndex: number;
  public menuModuleName: string;

  public itemTags: ItemTagViewModel[];
  public isItemTagEnabled: boolean = false;
  public itemTagType: ItemTagType = ItemTagType.Text;
  public likeIds: number[];
  private dislikeIds: number[] = [];
  private observers: MutationObserver[] = [];
  private _scrollListener: () => void;
  private _checkScrollTimer: any;
  private _initScrollTimer: any;
  public useRedeemCoupon: boolean = false;

  public isEMenu: boolean;
  public isSmallView: boolean = false;
  public atStart = true;
  public atEnd = false;
  public selectedDate: Date = null;
  public is_calendar_filter_enabled: boolean = false;
  public dates: { from: number, to: number }[] = [];
  public get isOrderModeTicket() {
    const me = this;
    return me._webShopService.getServiceMode() === WebShopMode.Ticket;
  }

  private _langSubscriber: Subscription;
  private _infiniteScrollSubscriber: Subscription;
  private _viewTypeSubscription: Subscription;
  private _shippingCartSubscriber: Subscription;

  public ArticleCardConfig: ArticleCardOptions;

  public tabSliderconfig: SwiperConfigInterface = {
    init: true,
    direction: "horizontal",
    slidesPerView: 4,
    freeMode: true,
    loop: false,
    spaceBetween: 0,
    keyboard: false,
    mousewheel: true,
    scrollbar: false,
    navigation: false,
    pagination: false,
    autoplay: false
  };

  @ViewChild("menuSearchInput", { read: MatInput }) searchInput: MatInput;
  @ViewChild(CalendarComponent) calendar: CalendarComponent;

  constructor(private _menuService: MenuService
    , private _internationalisationService: InternationalisationService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _activatedRoute: ActivatedRoute
    , private _snackBarService: SnackBarService
    , private _routerHelperService: RouterHelperService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _location: Location
    , private _router: Router
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _scrollHelper: ScrollHelper
    , private _iosHelperService: IOSHelperService
    , private _navigationService: NavigationService
    , private _eMenuService: EMenuService
    , private _itemTagHelperService: ItemTagHelperService
    , private _webShopService: WebShopService
    , private _materialTabHelperService: MaterialTabHelperService
    , private _mainnavService: MainnavService
    , private _elementRef: ElementRef
    , private _coreLanguageService: CoreLanguageService
    , private _webvoucherService: WebVoucherService) {
    this.isSmallView = this._mainnavService.viewType === ViewType.Small;
  }

  /** Component-scoped Lookup, vermeidet ID-Kollision mit menugroup. */
  private getHeaderTabs(): HTMLElement | null {
    return this._elementRef.nativeElement.querySelector("#headerTabs");
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("MenuComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.pagingHelper = new PagingHelper();
    me.sortOption = [];
    me.getRouteData();
    const currenttabIndex = me.itemGroups.findIndex(g => g.id === me.activeItemGroupId);
    me.currentItemGroupIndex = currenttabIndex > -1 ? currenttabIndex : 0;
    me.isEMenu = me._eMenuService.isActive;

    me._langSubscriber = this._internationalisationService.localeChanged.subscribe(() => {
      me.setModuleName();
      me.PushChanges();
    });

    me._shippingCartSubscriber = me._webShopService.ShippingCartObserver.subscribe((shippingCartItems) => {
      if (shippingCartItems) {
        me.itemsInBasket = me._webShopService.getTotalCountOfItems();
        me.PushChanges();
      } else {
        me.itemsInBasket = 0;
        me.PushChanges();
      }
    });

    me._menuService.ObserveChanges.subscribe(() => {
      me.reloadDataAndRender();
    });
    me.setModuleName();
    //me.initializeSortAndFilterOption();
    me.setInfiniteScrollSubscriber();
    me.PushChanges();
    me.setArticleCardConfig();
    me.setHeaderfocus();

    me._viewTypeSubscription = me._mainnavService.observeViewTypeChanges.subscribe((viewType) => {
      me.reloadDataAndRender();
    });
    me.reloadDataAndRender();
    me._checkUseRedeemCoupons()

    const headerTabs = me.getHeaderTabs();
    if (!headerTabs) return;
    const scrollContainer = headerTabs.querySelector('.mat-tab-label-container') as HTMLElement;
    if (!scrollContainer) return;

    me._scrollListener = () => {
      me.checkScrollPosition();
      me.PushChanges();
    };
    scrollContainer.addEventListener('scroll', me._scrollListener);

    me.checkScrollPosition();
    me._initScrollTimer = setTimeout(() => {
      const labels = Array.from(scrollContainer.querySelectorAll('.mat-tab-label')) as HTMLElement[];
      const centerOf = (label: HTMLElement) => {
        const target = label.offsetLeft - (scrollContainer.clientWidth / 2) + (label.clientWidth / 2);
        const max = Math.max(0, scrollContainer.scrollWidth - scrollContainer.clientWidth);
        return Math.max(0, Math.min(target, max));
      };
      const activeLabel = labels.find(label => label.classList.contains('mat-tab-label-active'));
      if (activeLabel) {
        scrollContainer.scrollLeft = centerOf(activeLabel);
      }
      labels.forEach((label) => {
        const observer = new MutationObserver(() => {
          if (label.classList.contains('mat-tab-label-active')) {
            scrollContainer.scrollTo({ left: centerOf(label), behavior: 'smooth' });
          }
        });
        observer.observe(label, { attributes: true, attributeFilter: ['class'] });
        me.observers.push(observer);
      });
    }, 200);
  }
  private setHeaderfocus() {
    const me = this;
    setTimeout(() => {
      const headerTabs = me.getHeaderTabs();
      if (!headerTabs) return;
      const matTabLabels = Array.from(headerTabs.getElementsByClassName("mat-tab-label")) as HTMLElement[];
      matTabLabels.forEach(label => {
        label.setAttribute("tabIndex", "0");
        label.addEventListener("keydown", (event: KeyboardEvent) => {
          if (event.key === "Enter") {
            event.preventDefault();
            const clickableSpan = label.querySelector('span');
            if (clickableSpan && typeof clickableSpan.click === 'function') {
              clickableSpan.click();
            }
          }
        });
      });
      if (matTabLabels.length > 0) {
        const firstLabel = matTabLabels[0];
        firstLabel.focus();
      }
    }, 200);
  }

  private setArticleCardConfig() {
    const me = this;
    const service = me._webShopService.getServiceMode();
    me.ArticleCardConfig = {
      checkAvailability: true,
      showPrice: true,
      allowAddingToBasket: (service !== WebShopMode.Viewing),
      allowViewingDetails: true,
      useECommerce: me._webShopService.useECommerce(),
    };
  }

  /**
   * Set the title of the page by title Data in route data
   * This data has been set in RouterHelperService by each navigationEnd Event
   */
  private getRouteData() {
    const me = this;
    // me.useBrowserHistory = me._activatedRoute.snapshot.data["useBrowserHistory"];
    const routeTargetData = me._activatedRoute.snapshot.data["routeTargetData"];
    if (routeTargetData && routeTargetData["activeItemGroupId"]) {
      me.activeItemGroupId = routeTargetData["activeItemGroupId"];
    } else {
      me.activeItemGroupId = +(me._activatedRoute.snapshot.paramMap.get("activeItemGroupId"));
    }
    me.webshopSettings = me._activatedRoute.snapshot.data["webshopSettings"];
    me.locationFilterId = +(me._activatedRoute.snapshot.data.locationId);
    if (me._activatedRoute.snapshot.data["itemGroups"] && me._activatedRoute.snapshot.data["itemGroups"].length > 0) {
      me.itemGroups = me._activatedRoute.snapshot.data["itemGroups"];
      me.menuSettingSortType = me._activatedRoute.snapshot.data["menuSettingData"].sortType;
    } else {
      me._location.back();
    }
  }

  /**set sorting option and filter at the first loading of the page */
  private initializeSortAndFilterOption() {
    const me = this;
    me.sortOption = [];
    if (me.isItemTagEnabled && me.itemTags && me.itemTags.length > 0 && me.hasTagSorting()) {
      me.sortOption.push(me.pagingHelper.createSortOption("amountOfLikedTags", SortDirection.DESC));
      me.itemGroups.sort(me.pagingHelper.fieldSorter(me.sortOption));
    }
    if (me.menuSettingSortType === MenuSettings_SortType.FreeItemnumber) {
      me.sortOption.push(me.pagingHelper.createSortOption("free_item_nr", SortDirection.ASC)); // bei der zuordnun in das view moddel sollte es bei 0 in 9999999999 damit sie nach der höchsten nummer kommen
    } else if (me.menuSettingSortType === MenuSettings_SortType.Alphabetic) {
      me.sortOption.push(me.pagingHelper.createSortOption("label", SortDirection.ASC));
    }
    // always sort by artikelNo last
    me.sortOption.push(me.pagingHelper.createSortOption("artikelNo", SortDirection.ASC));
  }

  /**check if there is liked or unliked tag
   * used to sort products base on liked and disliked tags
   */
  public hasTagSorting() {
    const me = this;
    return me._itemTagHelperService.hasTagSorting(me.itemTags);
  }

  /**check if there is disliked tag */
  private hasDislikeTag() {
    const me = this;
    return me._itemTagHelperService.hasDislikeTag(me.itemTags);
  }

  private async _checkUseRedeemCoupons() {
    const me = this;
    const use_redeem_coupon = await me._webShopService.isCouponReedemAllowed(false);
    if (me.useRedeemCoupon != use_redeem_coupon) {
      me.useRedeemCoupon = use_redeem_coupon;
      me.PushChanges();
    }
  }
  /**open Navigationmenu modal */
  public openNavModal() {
    const me = this;
    const headerTabs = me.getHeaderTabs();
    if (!headerTabs) return;
    const scrollContainer = headerTabs.querySelector('.mat-tab-label-container') as HTMLElement;
    if (!scrollContainer) return;
    const labels = Array.from(scrollContainer.querySelectorAll('.mat-tab-label')) as HTMLElement[];

    // Extrahieren Sie die Daten aus den .mat-tab-label Elementen
    const labelData = labels.map((label, index) => {
      return {
        text: label.textContent.trim(),
        isActive: label.classList.contains('mat-tab-label-active'),
        index: index
      };
    });

    me._bottomSheetHelperService.open(MenuNavDialogComponent, {
      data: {
        itemGroups: _.cloneDeep(me.itemGroups),
        labelData: labelData  // Übergeben Sie die Daten als labelData
      },
      autoFocus: false,
      panelClass: "mat-bottom-sheet-container-medium"
    });
    me.PushChanges();
  }
  public get allowReedemCoupon(): boolean {
    const me = this;
    const serviceId = me._webShopService.getServiceMode();
    return serviceId !== WebShopMode.Viewing;
  }

  public get isRemoteGroupOrder(): boolean {
    const me = this;
    const serviceId = me._webShopService.getServiceMode();
    return serviceId === WebShopMode.PickupGroup || serviceId === WebShopMode.DeliveryGroup;
  }

  // set subscriber for scrollbar and load data for next page when it is in the exact point.
  private setInfiniteScrollSubscriber() {
    const me = this;
    me._infiniteScrollSubscriber = me._scrollHelper.InfiniteScrollObserver().subscribe((result) => {
      const itemGroup = me.itemGroups[me.currentItemGroupIndex];
      if (itemGroup && itemGroup.productList) {
        const productList: IProductViewModel[] = [];
        productList.push(...me.paging[me.currentItemGroupIndex].nextPage());
        if (me.isItemTagEnabled && me.itemTags && me.itemTags.length > 0 && me.hasDislikeTag()) {
          const dislikeIds = me.itemTags.filter(t => t.itemTagStatus === ItemTagStatusType.dislike).map(m => m.id);
          itemGroup.productList.push(...productList.filter(p => !p.itemTags || p.itemTags.length === 0 || !p.itemTags.some(s => dislikeIds.includes(s.id))));
          itemGroup.dislikeProductList.push(...productList.filter(p => p.itemTags.some(t => dislikeIds.includes(t.id))));
        } else {
          itemGroup.productList.push(...productList);
        }
        (itemGroup.currentPage)++;
        me.PushChanges();
      }
    });
  }
  public scroll(percentageToScroll: number, direction: 'left' | 'right') {
    const me = this;
    const headerTabs = me.getHeaderTabs();
    if (!headerTabs) return;
    const scrollContainer = headerTabs.querySelector('.mat-tab-label-container') as HTMLElement;
    if (!scrollContainer) return;
    const labels = Array.from(scrollContainer.querySelectorAll('.mat-tab-label')) as HTMLElement[];
    const totalLabelWidth = labels.reduce((sum, label) => sum + label.offsetWidth, 0);
    const scrollAmount = totalLabelWidth * (percentageToScroll / 100);
    const targetScroll = direction === 'right'
      ? scrollContainer.scrollLeft + scrollAmount
      : scrollContainer.scrollLeft - scrollAmount;
    me.animateScroll(scrollContainer, targetScroll);
    me.checkScrollPosition();
  }

  public scrollRight() {
    const me = this;
    me.scroll(window.innerWidth <= 360 ? 10 : window.innerWidth <= 640 ? 15 : 25, 'right');
  }

  public scrollLeft() {
    const me = this;
    me.scroll(window.innerWidth <= 360 ? 10 : window.innerWidth <= 640 ? 15 : 25, 'left');
  }

  private animateScroll(element: HTMLElement, target: number) {
    const startTime = performance.now();
    const start = element.scrollLeft;
    const duration = 1000;
    const easeOut = (t: number) => t * (2 - t);
    const step = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const rawProgress = elapsed / duration;
      const progress = easeOut(rawProgress);
      const scrollPosition = start + (target - start) * progress;
      element.scrollLeft = scrollPosition;
      if (rawProgress < 1) {
        requestAnimationFrame(step);
      }
    };
    requestAnimationFrame(step);
  }

  public checkScrollPosition() {
    const me = this;
    const headerTabs = me.getHeaderTabs();
    if (!headerTabs) return;
    const scrollContainer = headerTabs.querySelector('.mat-tab-label-container') as HTMLElement;
    if (!scrollContainer) return;

    clearTimeout(me._checkScrollTimer);
    me._checkScrollTimer = setTimeout(() => {
      const labels = Array.from(scrollContainer.querySelectorAll('.mat-tab-label')) as HTMLElement[];
      const totalLabelWidth = labels.reduce((sum, label) => sum + label.offsetWidth, 0);
      const maxScrollPosition = Math.ceil(scrollContainer.scrollWidth - scrollContainer.clientWidth);
      const scrollPosition = Math.min(Math.ceil(scrollContainer.scrollLeft), maxScrollPosition);
      const tolerance = maxScrollPosition * 0.01;

      if (scrollPosition <= tolerance && totalLabelWidth >= scrollContainer.clientWidth) {
        me.atStart = true;
        me.atEnd = false;
      } else if (scrollPosition <= tolerance && totalLabelWidth <= scrollContainer.clientWidth) {
        me.atStart = true;
        me.atEnd = true;
      } else if (scrollPosition >= (maxScrollPosition - tolerance)) {
        me.atStart = false;
        me.atEnd = true;
      } else {
        me.atStart = false;
        me.atEnd = false;
      }
      me.PushChanges();
    }, 200);
  }

public onResize() {
    this.checkScrollPosition();
  }
  private async reloadDataAndRender() {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      if (me.webshopSettings && me.webshopSettings.is_itemtag_enabled) {
        me.itemTags = await me._itemTagHelperService.GetProductTags();
        if (me.itemTags && me.itemTags.length > 0) {
          me.isItemTagEnabled = me.webshopSettings.is_itemtag_enabled;
          me.itemTagType = me.webshopSettings.itemtag_type;
          me.likeIds = me.itemTags.filter(t => t.itemTagStatus === ItemTagStatusType.like).map(m => m.id);
          me.dislikeIds = me.itemTags.filter(t => t.itemTagStatus === ItemTagStatusType.dislike).map(m => m.id);
        }
      }
      if (me.webshopSettings && me.webshopSettings.is_calendar_filter_enabled) {
        me.is_calendar_filter_enabled = me.webshopSettings.is_calendar_filter_enabled;
        me.PushChanges();
      }
      const products = await me._menuService.GetProducts(me.locationFilterId, me.itemTags, me.likeIds, me.dislikeIds);
      me.productViewmodels = me.filterProducts(products);
      if (me.productViewmodels.length > 0) {
        me.pageSize = (me._mainnavService.viewType === ViewType.Small) ? 4 : 200; // Desktopview supports many more
        me.hasData = true;
        me.renderCurrentItemGroupPageing(true);
      } else {
        me.hasData = false;
      }
      me.checkScrollPosition();
      me.PushChanges();
      me._overlaySpinnerService.HideLayoutSpinner();
    } catch (e) {
      me._snackBarService.ShowErrorMessageFailed(60);
      me._coreLogService.error("MenuComponent.reloadDataAndRender", "try catch", e);
      me._overlaySpinnerService.HideLayoutSpinner();
    }
  }

  private filterProducts(products: IProductViewModel[]): IProductViewModel[] {
    const me = this;
    if (me._webShopService.getServiceMode() === WebShopMode.Webvoucher) {
      return products.filter(model => model.usingtype === UsingType.Webvoucher);
    } else {
      return products.filter(model => model.usingtype !== UsingType.Webvoucher);
    }
  }

  /**
   * Renders the current item group with paging
   * @param force - If true, reloads products from scratch. If false, uses cached paging data.
   */
  private renderCurrentItemGroupPageing(force: boolean) {
    const me = this;
    me.initializeSortAndFilterOption();

    const itemGroup = me.itemGroups[me.currentItemGroupIndex];
    if (!itemGroup) return;
    const allGroupProducts = me.getAllProductsForGroup(itemGroup, force);
    const filteredProducts = me.applyDateFilter(allGroupProducts);
    const currentPage = me.createOrUpdatePaging(filteredProducts, force);
    me.loadProductsForPage(itemGroup, currentPage);
    me.extractDatesForCalendar(allGroupProducts);

    me.PushChanges();
    me.animateItems();
  }

  /** Gets all products for the given item group */
  private getAllProductsForGroup(itemGroup: ItemGroupMenuViewModel, force: boolean): IProductViewModel[] {
    const me = this;
    if (force || Utils.IsNull(me.paging[me.currentItemGroupIndex])) {
      return me.productViewmodels.filter(p => p.isInGroup(itemGroup));
    } else {
      return me.paging[me.currentItemGroupIndex].getAllData();
    }
  }

  /** Applies date filter to products (ticket mode only) */
  private applyDateFilter(products: IProductViewModel[]): IProductViewModel[] {
    const me = this;
    if (me.is_calendar_filter_enabled && me.isOrderModeTicket) {
      // If calendar is enabled but no date is selected (no valid dates available), show no products
      if (!me.selectedDate) {
        me.hasData = false;
        return [];
      }
      return me._menuService.filterProductsByDate(products, me.selectedDate);
    }
    return products;
  }

  /**
   * Creates or updates paging with filtered products
   * @returns Current page number
   */
  private createOrUpdatePaging(filteredProducts: IProductViewModel[], force: boolean): number {
    const me = this;
    const itemGroup = me.itemGroups[me.currentItemGroupIndex];
    let currentPage = 2;
    if (!force && me.paging.length > 0 && !Utils.IsNull(me.paging[me.currentItemGroupIndex]) && itemGroup.currentPage) {
      currentPage = me.paging[me.currentItemGroupIndex].CurrentPage;
    }
    me.paging[me.currentItemGroupIndex] = new Paging(filteredProducts, me.pageSize, me.sortOption);
    return currentPage;
  }

  /** Loads products for the current page and applies tag filtering */
  private loadProductsForPage(itemGroup: ItemGroupMenuViewModel, currentPage: number): void {
    const me = this;
    itemGroup.currentPage = currentPage;
    itemGroup.productList = [];
    itemGroup.dislikeProductList = [];
    const productList = me.paging[me.currentItemGroupIndex].initLoad(currentPage);
    if (me.isItemTagEnabled && me.itemTags && me.itemTags.length > 0 && me.hasDislikeTag()) {
      const dislikeIds = me.itemTags.filter(t => t.itemTagStatus === ItemTagStatusType.dislike).map(m => m.id);

      itemGroup.productList.push(...productList.filter(p =>
        !p.itemTags || p.itemTags.length === 0 || !p.itemTags.some(s => dislikeIds.includes(s.id))
      ));
      itemGroup.dislikeProductList.push(...productList.filter(p =>
        p.itemTags && p.itemTags.some(t => dislikeIds.includes(t.id))
      ));
    } else {
      itemGroup.productList.push(...productList);
    }
  }


  /**
   * extract available dates for the calendar based on the products of the current item group (ticket mode only)
   * @param itemGroupProducts items of the current item group
   */
  private extractDatesForCalendar(itemGroupProducts: IProductViewModel[]) {
    const me = this;
    if (me.is_calendar_filter_enabled && me.isOrderModeTicket) {
      me.dates = me._menuService.getProductDates(itemGroupProducts);
    }
  }

  /* Opens the tag filter dialog, allowing the user to filter products by tag.  */
  public openTagsModal() {
    const me = this;
    const filterTagButtomSheet = me._bottomSheetHelperService.open(FilterTagDialogComponent, {
      data: { itemTags: _.cloneDeep(me.itemTags), itemTagType: me.itemTagType },
      panelClass: "mat-bottom-sheet-container--full-height"
    });
    filterTagButtomSheet.afterDismissed().subscribe((result: ItemTagViewModel[]) => {
      if (result) {
        me.itemTags = _.cloneDeep(result);
        me.reloadDataAndRender();
      }
    });
  }

  public headerTabFocusChange(event: MatTabChangeEvent) {
    const me = this;
    me._materialTabHelperService.TabHeaderTranslateAnimation(event);
  }

  /**
   * Handles switching between item groups when the user changes the active tab
   * @param tabIndex The index of the active tab
   */
  public itemGroupChange(tabIndex: number) {
    const me = this;
    me.currentItemGroupIndex = tabIndex;
    me.activeItemGroupId = me.itemGroups[tabIndex].id;
    me._webShopService.activeItemGroupId = me.activeItemGroupId;
    me._location.replaceState("/menu/" + me.activeItemGroupId)
    me.selectedDate = null;
    me.renderCurrentItemGroupPageing(false);

    // Reset calendar for new group with the newly extracted dates
    if (me.is_calendar_filter_enabled && me.isOrderModeTicket && me.calendar) {
      me.calendar.resetForNewGroup(me.dates);
    }
  }


  public emptyTabTitel() {
    const me = this;
    return me.is_calendar_filter_enabled && me.isOrderModeTicket ? "phEmptyTab_Tickets_Title" : "phEmptyTab_Title";
  }

  public emptyTabInfo() {
    const me = this;
    return me.is_calendar_filter_enabled && me.isOrderModeTicket ? "phEmptyTab_Tickets_Info" : "phEmptyTab_Info";
  }


  /**
   * Handles date selection by the user.
   * @param date The date selected by the user, or null if no date is selected.
   * @returns
   */
  public async onDateSelected(date: Date | null): Promise<void> {
    const me = this;
    me.selectedDate = date;
    if (!date) {
      me.hasData = false;
      me.PushChanges();
      return;
    }
    await me.reloadDataAndRender();
    me.PushChanges();
  }

  public navigateToCouponRedeem() {
    const me = this;
    me._router.navigate(["/couponRedeem"]);
  }

  /**When small view is true, navigation back by swiping from left to right.*/
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me._location.back();
    }
  }

public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  private setModuleName() {
    const me = this;
    me._navigationService.GetActiveNavigation()
      .then((navigations) => {
        const menuNav = navigations.find(navigation => navigation.contentType === ContentType.Menu);
        if (menuNav) {
          me.menuModuleName = menuNav.label;
        } else {
          me._coreLogService.error("MenuComponent.setModuleName", "Could not find Navigation for Menu");
        }
      })
      .catch(e => {
        me._coreLogService.error("MenuComponent.setModuleName", "_navigationService.GetActiveNavigation", e);
      });
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
    if (me._infiniteScrollSubscriber) {
      me._infiniteScrollSubscriber.unsubscribe();
    }
    if (me._viewTypeSubscription) {
      me._viewTypeSubscription.unsubscribe();
    }
    if (me._shippingCartSubscriber) {
      me._shippingCartSubscriber.unsubscribe();
    }
    const headerTabs = me.getHeaderTabs();
    if (headerTabs && me._scrollListener) {
      const scrollContainer = headerTabs.querySelector('.mat-tab-label-container') as HTMLElement;
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', me._scrollListener);
      }
    }
    clearTimeout(me._checkScrollTimer);
    clearTimeout(me._initScrollTimer);
    me.observers.forEach(observer => observer.disconnect());
    me.observers = [];
  }

  private animateItems() {
    const menu = document.getElementById("menuComponent")
    if (menu) {
      const activeTab = menu.getElementsByClassName("mat-tab-body-active")[0]
      if (activeTab) {
        const Items = activeTab.getElementsByClassName("item-column-container__item");
        for (let i = 0; i < Items.length; i++) {
          const element = Items[i];
          element.classList.remove("item-animated");
        }
        setTimeout(() => {
          for (let i = 0; i < Items.length; i++) {
            const element = Items[i];
            setTimeout(() => {
              element.classList.add("item-animated");
            }, i * 100)
          }
        }, 100)
      }
    }
  }
}
